
export default {
  auth: false,
  data() {
    return {
      componentName: 'Faq',
      activeTab: 0,
      policy: 'faq',
      tabsData: [
        { name: 'faq', compName: 'Faq', routeName: 'faq' },
        {
          name: 'terms and conditions',
          compName: 'TermsAndCondition',
          routeName: 'terms-and-conditions',
        },
        {
          name: 'privacy policy',
          compName: 'Policy',
          routeName: 'privacy-policy',
        },
        {
          name: 'do not sell',
          compName: 'DoNotSell',
          routeName: 'do-not-sell-my-personal-information',
        },
      ],
    }
  },
  fetch() {
    this.mapTabs()
  },
  // watch: {
  //   activeTab() {
  //     this.mapTabs()
  //   },
  // },
  methods: {
    mapTabs() {
      console.log(this.$route.params.name)
      this.tabsData.forEach((element, index) => {
        if (element.routeName === this.$route.params.name) {
          console.log(index)
          this.activeTab = index
          console.log(element)
          if (this.$breakpoint.is.smAndDown) {
            this.activeTab = element.routeName
          }

          this.componentName = element.compName
          this.$forceUpdate()
          console.log('this.componentName', this.componentName)
          if (element.name === 'terms and conditions') {
            this.policy = 'terms-and-condition'
          }
          if (element.name === 'privacy policy') {
            this.policy = 'privacy-policy'
          }
          if (element.name === 'do not sell') {
            this.policy = 'do-not-sell-my-personal-information'
          }
        }
      })
    },
    changeMenu(routeName) {
      console.log('this.activeTab changeMenu', this.activeTab)
      this.$router.push(this.localeRoute('/help-center/' + routeName))
    },
  },
}
